module.exports = __webpack_public_path__ + "static/img/hoverlogo04.c245cd5d.png";